import DifferentTogether from "./DifferentTogether";
export default DifferentTogether;